/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{982A14A0-F22C-42B2-9836-BF63575E6230}",
  "sitecoreApiHost": "https://mt.manutd.com",
  "sitecoreSiteName": "mt.manutd.com",
  "jssAppName": "mu-jss-app",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/mu-jss-app",
  "graphQLEndpoint": "https://mt.manutd.com/api/mu-jss-app?sc_apikey={982A14A0-F22C-42B2-9836-BF63575E6230}"
};